import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";

// Santé SYSTÈME du Raspberry (CPU/RAM/temp/throttling/services) via Infra API (SSH).
// Distincte de la télémétrie drone (Gateway/MAVLink). Polling doux (~9 s).
export function useRaspberryHealth(droneId, { interval = 9000, enabled = true } = {}) {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!droneId) return;
    setLoading(true);
    try {
      const { data } = await api.get(`/drones/${droneId}/raspberry-health`);
      setHealth(data);
      setError(data.reachable ? null : (data.reason || data.error || "indisponible"));
    } catch (e) {
      setError(e?.response?.data?.detail || "indisponible");
    } finally {
      setLoading(false);
    }
  }, [droneId]);

  useEffect(() => {
    if (!enabled) return;
    let stopped = false, timer = null;
    const run = async () => { await load(); if (!stopped) timer = setTimeout(run, interval); };
    run();
    return () => { stopped = true; if (timer) clearTimeout(timer); };
  }, [enabled, interval, load]);

  return { health, loading, error, reload: load };
}

export const HEALTH_META = {
  ok: { color: "#22C55E", label: "OK" },
  degraded: { color: "#F59E0B", label: "Degraded" },
  warning: { color: "#F59E0B", label: "Warning" },
  critical: { color: "#EF4444", label: "Critical" },
  unknown: { color: "#A3A3A3", label: "—" },
};

export const hm = (status) => HEALTH_META[status] || HEALTH_META.unknown;

export function fmtUptime(s) {
  if (s == null) return "—";
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
  if (d > 0) return `${d}j ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}
